import gql from 'graphql-tag';
import { StatFeatureCustomFte } from './stat-feature-custom-fte.fragment';
import { StatFeatureCustomRegistrationForms } from './stat-feature-custom-registration-forms.fragment';
import { StatFeatureHideNewEnquiryButtonFeature } from './stat-feature-hide-new-enquiry-button.fragment';
import { StatFeatureKinderConnect } from './stat-feature-kinder-connect.fragment';
import { StatFeatureLeaveRanges } from './stat-feature-leave-range.fragment';
import { StatFeatureMilkReport } from './stat-feature-milk-report.fragment';
import { StatFeatureOrgInquiries } from './stat-feature-org-level-inquiries.fragment';
import { StatFeatureOrgOccupancy } from './stat-feature-org-occupancy.fragment';
import { StatFeatureShiftPlanner } from './stat-feature-shift-planner.fragment';
import { StatFeatureStaffAttendancePage } from './stat-feature-staff-attendance-page.fragment';
import { StatFeatureStaffBreakRules } from './stat-feature-staff-break-rules.fragment';
import { StatFeatureStaffHours } from './stat-feature-staff-hours.fragment';
import { StatFeatureStaffHoursApproval } from './stat-feature-staff-hours-approval.fragment';
import { StatFeatureStaffLeaveSources } from './stat-feature-staff-leave-sources.fragment';
import { StatFeatureStaffLeaveV2 } from './stat-feature-staff-leave-v2.fragment';
import { StatFeatureStaffSignInOut } from './stat-feature-staff-sign-in-out.fragment';
import { StatFeatureSubType } from './stat-feature-subtype.fragment';
import { StatFeatureTaskManagement } from './stat-feature-task-management.fragment';
import { StatFeatureCareContract } from './stat-feature-care-contract.fragment';
import { StatFeatureCareRules } from './stat-feature-care-rules.fragment';
import { StatFeatureCareSummary } from './stat-feature-care-summary.fragment';
import { StatFeatureContractedHoursPerDay } from './stat-feature-contracted-hours-per-day.fragment';
import { StatFeatureStaffRatioV2 } from './stat-feature-staff-ratio-v2.fragment';
export const StatFeatures = gql `
    query StatFeatures($institutionSetId: InstitutionSetId!, $siteSetId: SiteSetId!) {
        featureSettings {
            careRules(siteSetId: $siteSetId) {
                ...StatFeatureCareRules
            }
            careSummary(siteSetId: $siteSetId) {
                ...StatFeatureCareSummary
            }
            staffRatioV2(siteSetId: $siteSetId) {
                ...StatFeatureStaffRatioV2
            }
        }
        staffhours {
            featureSettings {
                staffHours(siteSetId: $institutionSetId) {
                    ...StatFeatureStaffHours
                }
                approvalV2(siteSetId: $siteSetId) {
                    ...StatFeatureStaffHoursApproval
                }
                staffAttendancePage(siteSetId: $siteSetId) {
                    ...StatFeatureStaffAttendancePage
                }
                subtype(siteSetId: $institutionSetId) {
                    ...StatFeatureSubType
                }
                leaveRangeSettings(siteSetId: $institutionSetId) {
                    ...StatFeatureLeaveRanges
                }
                employeeCheckIn(siteSetId: $institutionSetId) {
                    ...StatFeatureStaffSignInOut
                }
                shiftplanner(siteSetId: $institutionSetId) {
                    ...StatFeatureShiftPlanner
                }
                staffLeave(siteSetId: $siteSetId) {
                    ...StatFeatureStaffLeaveV2
                }
                staffLeaveSources(siteSetId: $institutionSetId) {
                    ...StatFeatureStaffLeaveSources
                }
                contractedHoursPerDay(siteSetId: $institutionSetId) {
                    ...StatFeatureContractedHoursPerDay
                }
                staffBreakRules(siteSetId: $institutionSetId) {
                    ...StatFeatureStaffBreakRules
                }
            }
        }
        attendance {
            featureSettings {
                customFte(siteSetId: $institutionSetId) {
                    ...StatFeatureCustomFte
                }
                inquiry(siteSetId: $siteSetId) {
                    ...StatFeatureHideNewEnquiryButtonFeature
                    hideEnquiryCSVDownload
                    careRequestsEnabled
                    careRequestsEnabledForAnySite
                    heldPlacesEnabled
                }
                milkReport(siteSetId: $institutionSetId) {
                    ...StatFeatureMilkReport
                }
                kinderConnect(siteSetId: $institutionSetId) {
                    ...StatFeatureKinderConnect
                }
                newStarters(siteSetId: $siteSetId) {
                    isEnabled
                }
                customRegistrationForms(siteSetId: $institutionSetId) {
                    ...StatFeatureCustomRegistrationForms
                }
                orgOccupancy(siteSetId: $siteSetId) {
                    ...StatFeatureOrgOccupancy
                }
                orgInquiries(siteSetId: $siteSetId) {
                    ...StatFeatureOrgInquiries
                }
                taskManagement(siteSetId: $siteSetId) {
                    ...StatFeatureTaskManagement
                }
            }
        }
        childProfile {
            careContractFeatureSettings(siteSetId: $siteSetId) {
                ...StatFeatureCareContract
            }
        }
    }
    ${StatFeatureCareRules}
    ${StatFeatureCareSummary}
    ${StatFeatureStaffHours}
    ${StatFeatureStaffHoursApproval}
    ${StatFeatureCustomFte}
    ${StatFeatureHideNewEnquiryButtonFeature}
    ${StatFeatureSubType}
    ${StatFeatureMilkReport}
    ${StatFeatureKinderConnect}
    ${StatFeatureCustomRegistrationForms}
    ${StatFeatureLeaveRanges}
    ${StatFeatureStaffSignInOut}
    ${StatFeatureShiftPlanner}
    ${StatFeatureStaffAttendancePage}
    ${StatFeatureOrgOccupancy}
    ${StatFeatureOrgInquiries}
    ${StatFeatureStaffLeaveSources}
    ${StatFeatureStaffLeaveV2}
    ${StatFeatureTaskManagement}
    ${StatFeatureCareContract}
    ${StatFeatureContractedHoursPerDay}
    ${StatFeatureStaffRatioV2}
    ${StatFeatureStaffBreakRules}
`;
